import { Button } from "components/atoms/button/button";
import Joyride, { TooltipRenderProps } from "react-joyride";
import {
  ClassScheduleTooltipContainer,
  TooltipHeading
} from "./class-schedule-tooltip.styles";

const ClassScheduleTooltip: React.FC<{ onClick: () => void }> = ({
  onClick
}) => {
  const CustomTooltip = ({ step, tooltipProps }: TooltipRenderProps) => (
    <div
      {...tooltipProps}
      style={{
        padding: "20px",
        backgroundColor: "white",
        color: "black",
        borderRadius: "8px"
      }}
    >
      <h4>{step.title}</h4>
      <p>{step.content}</p>
    </div>
  );

  const steps = [
    {
      target: ".class-carousel",
      content: (
        <ClassScheduleTooltipContainer>
          <TooltipHeading>
            Ringkasan jadwal kelasmu setiap minggu
          </TooltipHeading>
          <Button variant="primary" onClick={onClick} isFullWidth={true}>
            Oke, siap
          </Button>
        </ClassScheduleTooltipContainer>
      ),
      placement: "top" as const,
      disableBeacon: true
    }
  ];

  return (
    <Joyride
      steps={steps}
      run={true}
      showSkipButton
      disableOverlayClose
      hideCloseButton
      tooltipComponent={CustomTooltip}
      styles={{ options: { zIndex: 5000 } }}
    />
  );
};

export default ClassScheduleTooltip;
